var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileCredits.jinja');
require('./MemberProfileCredits.less');

var Inner = require('front/components/MemberProfile/MemberProfileCreditsInner');
var Runtime = require('front/components/MemberProfile/MemberProfileCreditsInnerRuntime.jinja');

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'updateBlock');

        window.app.vent.on('MemberProfile--updateCredits', this.updateBlock);

        this.Inner = new Inner({
            el: this.$('.MemberProfileCreditsInner')[0]
        });

        Base.prototype.initialize.call(this, options);
    },


    deactivate: function (params) {
        window.app.vent.off('MemberProfile--updateCredits', this.updateBlock);

        this.Inner.deactivate();
        delete this.Inner;

        return Base.prototype.deactivate.call(this, params);
    },


    updateBlock: function (memberId) {
        this.Inner.deactivate();
        delete this.Inner;

        var data = window.app.data.members[memberId];

        var $template = $(Runtime.render({
            data: window.app.data.members[memberId],
            isOwner: window.app.settings.member == memberId
        }));

        this.$('.MemberProfileCredits-wrapper').html($template);

        this.Inner = new Inner({
            el: this.$('.MemberProfileCreditsInner')[0]
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfile/MemberProfileCredits.js
// module id = 187
// module chunks = 0